module.exports = __webpack_public_path__ + "static/media/menu-icon.8c088576.svg";